import React, {useContext} from 'react';
import {Card, message} from 'antd';
import UserRegisterForm, {IUserRegisterForm} from '../../components/user/RegisterForm';
import UseUser from '../../hooks/apis/useUser';
import QuickRouter from '../../utils/QuickRouter';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useQuickRouter from '../../utils/QuickRouter';

export default function UserRegisterPage() {
  const registerState = UseUser.register();
  const quickRouter = useQuickRouter();

  function register(form: IUserRegisterForm) {
    registerState
      .request(form)
      .then(() => {
        message.success('注册成功');
        return quickRouter.userProfile();
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <div>
      <UserRegisterForm isLoading={registerState.loading} onFinish={register} />
    </div>
  );
}
